import { render, staticRenderFns } from "./Substitute.vue?vue&type=template&id=2ce91c3e&scoped=true"
import script from "./Substitute.vue?vue&type=script&lang=js"
export * from "./Substitute.vue?vue&type=script&lang=js"
import style0 from "./Substitute.vue?vue&type=style&index=0&id=2ce91c3e&prod&lang=less&scoped=true"
import style1 from "./Substitute.vue?vue&type=style&index=1&id=2ce91c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce91c3e",
  null
  
)

export default component.exports